import MainContent from './PageContent';
import { DesktopOnly, MobileOnly } from './PageContent.style';

export default MainContent;
export { DesktopOnly, MobileOnly };
